import React from 'react';
import { change, Field, reduxForm } from 'redux-form';
import Card from '../../shared/components/Card';
import CardSimpleHeader from '../../shared/components/CardSimpleHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CardBody from '../../shared/components/CardBody';
import Row from '../../shared/components/Row';
import FormField from '../../shared/components/FormField';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as workActions from '../actions/workActions';
import * as schemaTypeActions from '../../documents/actions/schemaTypeActions';
import DateUtils from '../../shared/utils/DateUtils';
import moment from 'moment/moment';
import { CurrentUser } from '../../shared/model/CurrentUser';

class AddWorkCard extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentWillMount() {
        this.props.schemaTypeActions.getWorkDocumentSchemaState();
        this.props.schemaTypeActions.getWorkDocumentLinkSchemaState();
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevProps.workImported !== this.props.workImported ) {
            if ( this.props.workImported ) {
                this.props.change('code', this.props.workImported.codigoObra);
                this.props.change('name', this.props.workImported.nombreAbreviadoObra);
                this.props.change('notes', this.props.workImported.nombreCompletoObra);
                if ( this.props.workImported.fechaInicio ) {
                    const date = new Date(this.props.workImported.fechaInicio);
                    this.props.change('start_date', moment(date, 'DD/MM/YYYY'));
                } else {
                    this.props.change('start_date', ' ');
                }
                if ( this.props.workImported.fechaFin ) {
                    const date = new Date(this.props.workImported.fechaFin);
                    this.props.change('end_date', moment(date, 'DD/MM/YYYY'));
                } else {
                    this.props.change('end_date', ' ');
                }
            }
        }
    }

    onSubmit(values) {
        values.construction_state_id = values.state ? 1 : 2; // Activo: 1; Inactivo: 2;
        values.contracts = [];

        if ( typeof values.start_date === 'string' ) {
            values.start_date = DateUtils.buildDateFromString(values.start_date);
        }
        if ( typeof values.end_date === 'string' ) {
            values.end_date = DateUtils.buildDateFromString(values.end_date);
        }

        const constructionSave = this.parserSubmit(values);
        this.props.workActions.addWork(constructionSave);
    }

    parserSubmit = (
        {
            code,
            construction_state_id,
            document_schema_id,
            document_schema_link_id,
            end_date,
            name,
            notes,
            start_date,
            state,
            email_alerts,
        },
    ) => ( {
        code,
        construction_state_id,
        contracts: [],
        document_schema_id: document_schema_id && Number(document_schema_id) !== -1 ? Number(document_schema_id) : null,
        document_schema_link_id: document_schema_link_id && Number(document_schema_link_id) !== -1 ? Number(document_schema_link_id) : null,
        end_date: DateUtils.buildDateFromString(end_date).toISOString(),
        name,
        notes,
        start_date: DateUtils.buildDateFromString(start_date).toISOString(),
        state,
        email_alerts,
    } );

    renderField(field) {
        return <FormField field={field}/>;
    }

    render() {
        const {
            handleSubmit,
            currentUser,
        } = this.props;
        const enableEmailAlerts = currentUser.enableEmailAlerts();

        return (
            <Card loading={this.props.loading}>
                <CardSimpleHeader title={I18nUtils.tr('TR_NUEVA_OBRA')}/>
                <CardBody>
                    <form onSubmit={handleSubmit(this.onSubmit)}>

                        <Row>
                            <Field
                                ref={'codeRef'}
                                label={I18nUtils.tr('TR_CODIGO') + ':'}
                                placeholder={I18nUtils.tr('TR_CODIGO')}
                                name="code"
                                type={'text'}
                                colWidth="col-sm-2"
                                component={this.renderField}
                            />
                            <Field
                                ref={'nameRef'}
                                label={I18nUtils.tr('TR_NOMBRE') + ':'}
                                placeholder={I18nUtils.tr('TR_NOMBRE_DE_LA_OBRA')}
                                name="name"
                                type={'text'}
                                colWidth="col-sm-6"
                                component={this.renderField}
                            />
                            <Field
                                label={I18nUtils.tr('TR_ESTADO')}
                                labelDisabled={I18nUtils.tr('TR_INACTIVA')}
                                labelEnabled={I18nUtils.tr('TR_ACTIVA')}
                                defaultChecked={true}
                                name="state"
                                checked={true}
                                type={'checkbox'}
                                colWidth="col-sm-4"
                                component={this.renderField}
                            />
                        </Row>

                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_FECHA_INICIO')}
                                placeholder={I18nUtils.tr('TR_FECHA_INICIO')}
                                name="start_date"
                                type={'date'}
                                colWidth="col-sm-6"
                                component={this.renderField}
                            />
                            <Field
                                label={I18nUtils.tr('TR_FECHA_FIN')}
                                placeholder={I18nUtils.tr('TR_FECHA_FIN')}
                                name="end_date"
                                type={'date'}
                                colWidth="col-sm-6"
                                component={this.renderField}
                            />
                        </Row>

                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_DESCRIPCION_DE_LA_OBRA')}
                                placeholder=""
                                name="notes"
                                type={'textarea'}
                                rows={2}
                                colWidth="col-sm-12"
                                component={this.renderField}
                            />
                        </Row>

                        <Row>
                            {/*<Field*/}
                            {/*    label={I18nUtils.tr('TR_ESQUEMA_DE_DOCUMENTOS') + ':'}*/}
                            {/*    name="document_schema_id"*/}
                            {/*    type={'selectSimple'}*/}
                            {/*    options={this.props.workSchemaOptions}*/}
                            {/*    colWidth="col-sm-6"*/}
                            {/*    component={this.renderField}*/}
                            {/*/>*/}
                            <Field
                                label={I18nUtils.tr('TR_DOCUMENTOS_VINCULADOS') + ':'}
                                name="document_schema_link_id"
                                type={'selectSimple'}
                                options={this.props.linkedDocumentsOptions}
                                colWidth="col-sm-6"
                                component={this.renderField}
                            />
                        </Row>
                        {
                            enableEmailAlerts &&
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_EMAIL_PARA_AVISOS') + ':'}
                                    name="email_alerts"
                                    type={'email'}
                                    colWidth="col-sm-6"
                                    component={this.renderField}
                                />
                            </Row>
                        }

                        <Row>
                            <Field
                                label={I18nUtils.tr('TR_CREAR').toUpperCase()}
                                name="submit"
                                type={'submit'}
                                colWidth="col-md-12"
                                component={this.renderField}
                            />
                        </Row>

                    </form>
                </CardBody>
            </Card>
        );
    }

}

function validate(values) {
    const errors = {};

    if ( !values.code ) {
        errors.code = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }
    if ( !values.name ) {
        errors.name = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    if ( !DateUtils.isValidDate(values.start_date) ) {
        errors.start_date = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    if ( !DateUtils.isValidDate(values.end_date) ) {
        errors.end_date = I18nUtils.tr('TR_FECHA_INVALIDA');
    }

    if ( DateUtils.isValidDate(values.start_date) && DateUtils.isValidDate(values.end_date) ) {
        let startDate = values.start_date;
        if ( typeof startDate === 'string' ) {
            startDate = DateUtils.buildDateFromString(startDate);
        }
        let endDate = values.end_date;
        if ( typeof endDate === 'string' ) {
            endDate = DateUtils.buildDateFromString(endDate);
        }

        if ( startDate > endDate ) {
            errors.start_date = I18nUtils.tr('TR_FECHA_INICIO_NO_PUEDE_SER_MAYOR_QUE_FIN');
            // errors.start_date = I18nUtils.tr('TR_FECHA_INVALIDA');
        }
    }
    // if (!values.start_date) {
    //   errors.start_date = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }
    // if (!values.end_date) {
    //   errors.end_date = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }
    // if (!values.notes) {
    //   errors.notes = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }
    // if (!values.document_schema_id || values.document_schema_id === -1 || values.document_schema_id === '-1') {
    //   errors.document_schema_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    // }

    return errors;
}

AddWorkCard = reduxForm({
    validate,
    form: 'AddWorkForm',
})(AddWorkCard);

const mapStateToProps = (state, ownProps) => {

    const workSchemaOptions = state.schemaType.workDocumentSchemaType.map((schema) => {
        return {
            value: schema.id,
            name: schema.name,
        };
    });

    const linkedDocumentsOptions = state.schemaType.workDocumentSchemaLinkType.map((schema) => {
        return {
            value: schema.id,
            name: schema.name,
        };
    });

    let workValues = { state: true };

    return {
        initialValues: workValues,
        loading: state.works.workAddLoading,
        workSchemaOptions: workSchemaOptions,
        linkedDocumentsOptions: linkedDocumentsOptions,
        workImported: state.worksImport.workImported,
        currentUser: CurrentUser.fromReduxState(state),
    };
};

const mapDispatchToProps = dispatch => ( {
    workActions: bindActionCreators(workActions, dispatch),
    schemaTypeActions: bindActionCreators(schemaTypeActions, dispatch),
    change: bindActionCreators({ change }, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(AddWorkCard);



// WEBPACK FOOTER //
// ./src/app/works/components/AddWorkCard.jsx